import Vec2 from 'gl-vec2';
import Vec3 from 'gl-vec3';

import { lerp, lerpAngle, lerpVec3 } from './lerp';

const angleDifference = (a, b) => ((a - b + Math.PI) % (2*Math.PI) + (2*Math.PI)) % (2*Math.PI) - Math.PI;

const makeCamera = (camera) => {
  const initialState = {
    position: Vec3.clone(camera.position),
    lookingAt: Vec3.fromValues(0, 3, 0),
    angle: 0,
  };
  
  const update = (state, dt, { movement }, playerState) => {
    state.position = Vec3.clone(state.position);
    state.lookingAt = Vec3.clone(state.lookingAt);
    
    if (Vec2.length(movement) > 0) {
      const targetAngle = Math.atan2(movement[0], movement[1]);
      if (Math.abs(angleDifference(targetAngle, state.angle)) < 0.7 * Math.PI) {
        const lerpSpeed = playerState.mode === 'grounded' ? 0.05 : 0.02;
        state.angle = lerpAngle(state.angle, targetAngle, lerpSpeed, dt*60);
      }
    }
    
    const targetPosition = Vec3.fromValues(-Math.sin(state.angle), 0, -Math.cos(state.angle));
    Vec3.normalize(targetPosition, targetPosition);
    Vec3.scaleAndAdd(targetPosition, playerState.position, targetPosition, 10);
    targetPosition[1] += 5;
    lerpVec3(state.position, targetPosition, 0.1, dt*60);
    
    const targetLookingAt = Vec3.add([], playerState.position, [0, 3, 0])
    lerpVec3(state.lookingAt, targetLookingAt, 0.2, dt*60);
    
    if (playerState.mode !== 'grounded' && targetPosition[1] > state.position[1]) {
      state.position[1] = lerp(state.position[1], targetPosition[1], 0.01, dt*60);
    }
    
    return state;
  };
  
  const interpolate = (state, nextState, factor) => {
    camera.up = [0, 1, 0];
    Vec3.copy(camera.position, state.position);
    const lookingAt = Vec3.clone(state.lookingAt);
    lerpVec3(camera.position, nextState.position, factor);
    camera.lookAt(lerpVec3(lookingAt, nextState.lookingAt, factor));
  };
  
  return [update, initialState, interpolate];
};

export default makeCamera;